import React, { ReactElement, ReactNode } from 'react';
import styled from 'styled-components';

interface ILoaderContainerProps {
  className?: string;
  loader: ReactNode;
  children: ReactNode;
  isLoading?: boolean;
}

const LoaderWrapper = ({ loader, children, isLoading, className }: ILoaderContainerProps): ReactElement => {
  return isLoading ? <Container className={className}>{loader}</Container> : <>{children}</>;
};

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export { LoaderWrapper };
